import classNames from 'classnames';

import CleanLinkButton from '../../../../components/CleanLinkButton/CleanLinkButton';
import WrapIf from '../../../../components/WrapIf/WrapIf';
import Logo from '../../../../types/UI/Logo';
import Tenant from '../../../types/Tenant';

import styles from './LogoLink.module.css';

type LogoLinkProps = {
    logo: Logo;
    tenant: Tenant;
    url?: string;
    minimalMode?: boolean;
    target?: '_blank' | '_self' | '_parent' | '_top';
};

const LogoLink = ({
    logo,
    tenant,
    url,
    minimalMode = false,
    target = '_self',
}: LogoLinkProps) => {
    return (
        <WrapIf
            condition={!!url}
            wrapper={(children) => (
                <CleanLinkButton
                    href={url}
                    disableInertia={target === '_blank'}
                    target={target}
                    className={styles.Root}
                >
                    {children}
                </CleanLinkButton>
            )}
        >
            <img
                src={logo.variants.default.path}
                alt={tenant.name}
                className={classNames(styles.Image, {
                    [styles.minimal]: minimalMode,
                })}
            />
        </WrapIf>
    );
};

export default LogoLink;
